<template>
  <div class="file file_upload" :class="{'complete': !loading}">
    <div class="doc">
        <svg viewBox="0 0 40 40">
          <use href="#doc"></use>
        </svg>
        <div class="doc__type">{{ext}}</div>
    </div>
    <div class="file__descr">
        <div class="file__name">{{filename}}</div>
        <div class="file__bar" v-if="loading">
          <div class="file__bar file__bar_percent" :style="{'width': percentage + '%'}"></div>
        </div>
        <div class="file__size">{{filesize}}</div>
    </div>
    <div class="file__actions" v-if="actions">
        <div>
          <button class="file__control">
              <svg viewBox="0 0 24 24">
                <use href="#edit"></use>
              </svg>
          </button>
          <button class="file__control">
              <svg viewBox="0 0 24 24">
                <use href="#trash"></use>
              </svg>
          </button>
          <button class="file__control close">
              <svg viewBox="0 0 14 14">
                <use href="#close"></use>
              </svg>
          </button>
        </div>
        <div class="file__percent">100</div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      percentage: {type: Number, default: 0},
      loading: {type: Boolean, default: false},
      actions: {type: Boolean, default: false},
      filename: {type: String, default: 'No name'},
      filesize: {type: String, default: '123.4 KB'},
      ext: {type: String, default: 'png'},
    }
  }
</script>

<style lang="sass">
@use 'sass:math'
$whiteF: #F7F7F7
$grey7: #797979
$dark: #250708
$greyC: #C4C4C4
$greyE: #E8E8EC
$active: #E9041E

$height: 80px
$padding: 14px
@keyframes fileappear
  0%
    max-height: 0
    padding-top: 0
    padding-bottom: 0
  100%
    max-height: 54px
    padding-top: 4px

@keyframes filechange
  0%
    opacity: 0
  100%
    opacity: 1
.file
  max-height: 54px
  display: flex
  position: relative
  padding-top: 4px
  transition: all .3s ease-out, outline 0s
  .doc
    padding-top: 3px
  button
    padding: 0
    cursor: pointer
    background: none
    border: none
  &.complete  
    animation: none
  &.have
    animation: shake .3s linear
  &.deleting
    overflow: hidden
    margin: 0 !important
    max-height: 0px
    padding-top: 0
    padding-bottom: 0
    opacity: 0
    &:first-of-type + .file
      margin-top: 0
    &:first-of-type + .droparea
      margin-top: 0
  &__descr,&__actions
    position: relative
    margin-left: 21px
    display: flex
    flex-direction: column
    justify-content: space-around
  &__descr
    overflow: hidden
    margin-left: 16px
    height: 49px
    margin-top: 0
    justify-content: space-between
  &__name
    font-size: 14px
    line-height: math.div(23,14)
    color: $dark
    white-space: nowrap
    text-overflow: ellipsis
    overflow: hidden
  &__size, &__percent
    font-size: 11px
    line-height: math.div(16,11)
    text-transform: uppercase
    color: $grey7
  &__percent
    font-size: 12px
    line-height: 16px
    margin-right: -3px
  &__actions
    padding-right: 3px
    position: absolute
    height: 54px
    align-items: flex-end
    right: 0
  &__control
    width: 14px
    height: 14px
    margin: 0 13px
    display: none
    &:last-child
      margin-right: 3px
    &.close
      display: inline-block
    &:not(.close)
      transform: scale(1.8) translateY(-1px)
      &:nth-last-child(2)
        margin-right: 3px
  &.complete &__control
    display: inline-block
    &.close
      display: none
  &.complete &__percent, &.complete &__bar
    display: none
    

  &__percent
    text-transform: none
    &::before
      content: 'Uploading... '
    &::after
      content: '%'
  &_upload
    width: 100%
    animation: fileappear .4s ease
  &_uploadchange
    animation: filechange .4s ease
  &_upload &__descr
    flex-grow: 1
    padding-right: 120px
  &_upload + .droparea
    margin-top: 33px
  &__bar
    position: absolute
    width: 100%
    margin-top: 25px
    background: $whiteF
    border-radius: 2px
    height: 4px
    &_percent
      position: static
      width: 0
      margin-top: 0
      background: $active
</style>